(() => {
  const links = Array.from(document.querySelectorAll('.hilite-migrated-gallery a[href]'));
  if (!links.length || typeof HTMLDialogElement === 'undefined') return;

  const dialog = document.createElement('dialog');
  dialog.className = 'hilite-lightbox';
  dialog.setAttribute('aria-label', 'Gallery image');
  dialog.innerHTML = `
    <div class="hilite-lightbox__stage">
      <button class="hilite-lightbox__close" type="button" aria-label="Close">×</button>
      <button class="hilite-lightbox__previous" type="button" aria-label="Previous image">‹</button>
      <img class="hilite-lightbox__image" alt="">
      <button class="hilite-lightbox__next" type="button" aria-label="Next image">›</button>
    </div>`;
  document.body.appendChild(dialog);

  const image = dialog.querySelector('.hilite-lightbox__image');
  const closeButton = dialog.querySelector('.hilite-lightbox__close');
  const previousButton = dialog.querySelector('.hilite-lightbox__previous');
  const nextButton = dialog.querySelector('.hilite-lightbox__next');
  let currentIndex = 0;
  let opener = null;

  const showImage = (index) => {
    currentIndex = (index + links.length) % links.length;
    const link = links[currentIndex];
    const thumbnail = link.querySelector('img');
    image.src = link.href;
    image.alt = thumbnail ? thumbnail.alt : '';
  };

  links.forEach((link, index) => {
    link.removeAttribute('target');
    link.removeAttribute('rel');
    link.addEventListener('click', (event) => {
      event.preventDefault();
      opener = link;
      showImage(index);
      dialog.showModal();
      closeButton.focus();
    });
  });

  closeButton.addEventListener('click', () => dialog.close());
  previousButton.addEventListener('click', () => showImage(currentIndex - 1));
  nextButton.addEventListener('click', () => showImage(currentIndex + 1));
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    image.removeAttribute('src');
    if (opener) opener.focus();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (event.key === 'ArrowRight') showImage(currentIndex + 1);
  });
})();
